import { __extends } from "tslib";
import { DeleteBucketMetricsConfigurationRequest } from "../models/index";
import { deserializeAws_restXmlDeleteBucketMetricsConfigurationCommand, serializeAws_restXmlDeleteBucketMetricsConfigurationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteBucketMetricsConfigurationCommand = /** @class */ (function (_super) {
    __extends(DeleteBucketMetricsConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteBucketMetricsConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteBucketMetricsConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteBucketMetricsConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteBucketMetricsConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteBucketMetricsConfigurationCommand(input, context);
    };
    DeleteBucketMetricsConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteBucketMetricsConfigurationCommand(output, context);
    };
    return DeleteBucketMetricsConfigurationCommand;
}($Command));
export { DeleteBucketMetricsConfigurationCommand };
//# sourceMappingURL=DeleteBucketMetricsConfigurationCommand.js.map